import { render, staticRenderFns } from "./SpinnerBox.vue?vue&type=template&id=7e5f671f&"
import script from "./SpinnerBox.vue?vue&type=script&lang=js&"
export * from "./SpinnerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports